import reportTypes from './report.types';

export const createReportAction = (payload, cb, cbError) => ({
  type: reportTypes.CREATE_REPORT,
  payload,
  cb,
  cbError
});

export const getReportsAction = (payload, cb, cbError) => ({
  type: reportTypes.FETCH_REPORTS,
  payload,
  cb,
  cbError
});

export const getSingleReportAction = (payload, cb, cbError) => ({
  type: reportTypes.FETCH_SINGLE_REPORT,
  payload,
  cb,
  cbError
});

export const getAllTestAction = (cb, cbError) => ({
  type: reportTypes.FETCH_TESTS,
  cb,
  cbError
});

export const editReportAction = (payload, cb, cbError) => ({
  type: reportTypes.EDIT_TESTS,
  payload,
  cb,
  cbError
});

export const deleteSingleReportAction = (payload, cb, cbError) => ({
  type: reportTypes.DELETE_SINGLE_REPORT,
  payload,
  cb,
  cbError
});

export const createDiagnosticFindingsAction = (payload, cb, cbError) => ({
  type: reportTypes.CREATE_DIAGNOSTIC_FINDING,
  payload,
  cb,
  cbError
});

export const createDiagnosticNotesAction = (payload, cb, cbError) => ({
  type: reportTypes.ADD_DIAGNOSTIC_NOTES,
  payload,
  cb,
  cbError
});


export const getFindingsPerProcedureAction = (payload, cb, cbError) => ({
  type: reportTypes.FETCH_FINDINGS_PER_PROCEDURE,
  payload,
  cb,
  cbError
});

export const getNotesPerFindingsAction = (payload, cb, cbError) => ({
  type: reportTypes.FETCH_NOTES_PER_FINDINGS,
  payload,
  cb,
  cbError
});

export const editDiagnosticFindingsAction = (payload, cb, cbError) => ({
  type: reportTypes.EDIT_DIAGNOSTIC_FINDINGS,
  payload,
  cb,
  cbError
});

export const editDiagnosticFindingNotesAction = (payload, cb, cbError) => ({
  type: reportTypes.EDIT_DIAGNOSTIC_FINDINGS_NOTE,
  payload,
  cb,
  cbError
});
export const deleteDiagnosticFindingAction = (payload, cb, cbError) => ({
  type: reportTypes.DELETE_DIAGNOSTIC_FINDINGS,
  payload,
  cb,
  cbError
});

